import React from 'react';

export const Folder = (props: React.SVGProps<SVGSVGElement>) => {
   return (
      <svg
         width="44"
         height="35"
         viewBox="0 0 44 35"
         fill="currentColor"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <g clipPath="url(#clip0_29_161)">
            <path
               d="M42.7849 12.9481C41.8785 11.8605 40.697 11.2362 39.5557 11.2362H38.6695C38.6695 11.0012 38.6762 10.7595 38.6829 10.5312C38.7165 9.13484 38.7501 7.68474 37.8236 6.31519C36.971 5.05306 35.6216 4.31458 33.9231 4.18703C31.7614 4.0259 29.4855 4.09975 27.2835 4.16689C25.1688 4.23402 22.9869 4.30116 20.9661 4.16689C20.2679 4.06618 19.6436 3.40827 18.9252 2.64293C17.9518 1.60906 16.8508 0.447631 15.1388 0.273081C13.3061 0.091818 11.3055 0.172379 9.3787 0.246228C7.66005 0.313362 5.88099 0.38721 4.26305 0.266368H4.20262H4.1422C1.92005 0.622181 0.221544 2.40796 0 4.67711V30.4769C0.241684 32.8266 2.16173 34.6997 4.49802 34.834H35.3128C37.2798 34.5923 38.6628 33.4376 39.4214 31.3967C40.4419 28.6643 41.2743 25.7238 42.0799 22.8773C42.664 20.8163 43.2682 18.6881 43.9262 16.6875L43.9463 16.6136C44.1544 15.4388 43.7247 14.0692 42.7849 12.9414V12.9481ZM36.0244 11.2362H8.80806C7.27739 11.2362 5.44461 12.6527 4.83369 13.9215L2.63839 20.6954V4.57641C2.63839 4.01919 3.68569 2.98532 4.31004 2.91818C5.90784 3.03903 7.64663 2.96518 9.33842 2.88462C11.2316 2.79734 13.1919 2.71007 14.9039 2.91147C15.6424 2.99874 16.2734 3.67009 17.0052 4.44214C17.9921 5.48272 19.1132 6.66429 20.899 6.8187C23.0943 7.00668 25.4507 6.92612 27.7333 6.83884C29.8346 6.76499 32.0031 6.68443 34.0372 6.82542C34.8093 6.85898 36.0311 7.81901 36.0311 8.57763V11.2227L36.0244 11.2362ZM2.86665 28.8523C3.51114 26.422 4.34361 23.9514 5.14251 21.5615C5.84742 19.4534 6.57919 17.2783 7.19011 15.13C7.5325 14.425 8.10314 14.0357 8.96918 13.9081L39.1126 13.8745C39.8444 13.935 40.4687 14.2438 40.8648 14.7406C41.2206 15.1837 41.3683 15.7476 41.2945 16.372C40.5627 18.4934 39.9249 20.7223 39.3073 22.8773C38.589 25.3747 37.8505 27.9527 36.9643 30.3628C36.6286 31.2758 36.3332 31.7726 35.5947 32.068C26.216 32.2896 16.6292 32.2157 7.36466 32.1486L4.18248 32.1284C2.75252 31.5108 2.38999 30.6112 2.85993 28.859L2.86665 28.8523Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_29_161">
               <rect
                  width="44"
                  height="34.6683"
                  fill="currentColor"
                  transform="translate(0 0.165894)"
               />
            </clipPath>
         </defs>
      </svg>
   );
};
